// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4118":"2e893bbc","4569":"4c6ef76f","6683":"2e893bbc","7560":"2e893bbc","7833":"2e893bbc"}[chunkId] + ".chunk.css";
};